import { action, observable } from 'mobx';
import { DateTime } from 'luxon';
import { RootStore } from './rootStore';

export interface GlobalError {
  timestamp: string;
  error: string;
}

export class ErrorStore {
  rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @observable globalErrors: GlobalError[] = [];
  @observable errorDialog = false;
  @observable customErrorDialog: string | undefined = '';
  @observable autoHide = true;

  @action addGlobalError = (error: string) => {
    const timestamp = DateTime.local().toFormat('dd.MM.yyyy HH:mm:ss');
    const globalError = { timestamp, error };
    this.globalErrors.push(globalError);
  };

  addGenericGlobalError = () => {
    this.addGlobalError('globalErrors_generic');
  };

  @action
  disableAutoHide = () => (this.autoHide = false);

  @action clearGlobalErrors = () => {
    this.globalErrors = [];
    this.autoHide = true;
  };

  @action showErrorDialog = (customMessage?: string) => {
    this.customErrorDialog = customMessage;
    this.errorDialog = true;
  };

  @action hideErrorDialog = () => {
    this.errorDialog = false;
    this.customErrorDialog = undefined;
  };
}
